import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

export interface MinuteStageApprovedState {
    stageData: any,
    imagePath: any,
    zeroStage: any,
    isFetching: boolean,
    isStageDataSuccess: boolean,
    isError: boolean,
    errorMessage: any,
}


const initialState: MinuteStageApprovedState = {
    stageData: [],
    imagePath: '',
    zeroStage: [],
    isFetching: false,
    isStageDataSuccess: false,
    isError: false,
    errorMessage: '',
};

export const getMinuteStageApprover: any = createAsyncThunk(
    'minutesStageWise?processId=',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;
            // let userType = auth.user.userType == 'CHD'?'chd':auth.user.userType == "DD's & AD's"?'DDsAndAds':'clerk';
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            let response = await axios({
                url: `/api${userType}/minutesStageWise?processId=${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);



export const MinuteStageApproverSlice = createSlice({
    name: 'minutestageapprover',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearStateMinuteStageApprover: (state, { payload }: PayloadAction) => {
            // state.stageData = [];
            state.isFetching = false;
            state.isStageDataSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getMinuteStageApprover.fulfilled]: (state, { payload }) => {

            state.stageData = payload.data;
            state.imagePath = payload.data.imagePath;
            state.zeroStage = payload.data.zeroStage
            state.isFetching = false;
            state.isStageDataSuccess = true;
            return state;
        },

        [getMinuteStageApprover.pending]: (state) => {
            state.isFetching = false;
        },

        [getMinuteStageApprover.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateMinuteStageApprover } = MinuteStageApproverSlice.actions;

export function clearState() {

    return async (dispatch: any) => {
        dispatch(clearStateMinuteStageApprover());
    };
}

export const MinuteStageApproverSelector = (state: any) => state.minutestageapprover;

export default MinuteStageApproverSlice.reducer;
